import React from 'react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, Button } from '@chakra-ui/react';
import { PageContainer } from '../../layouts/PageContainer';
import { PageHeader } from '../../layouts/PageHeader';
import { Link } from 'react-router-dom';

const PendingRequestsPage = () => {
    // Dummy Data (Hard Coded) - Only Examples 
    const tableData = [
        { id: 1, age: 30, year: 1994, height: '', weight: '', relation: '' },
        { id: 2, age: 30, year: 1994, height: '', weight: '', relation: '' },
        { id: 3, age: 29, year: 1995, height: '', weight: '', relation: '' },
        { id: 4, age: 28, year: 1996, height: '', weight: '', relation: '' },
        { id: 5, age: 1, year: 2023, height: '', weight: '', relation: '' },
        { id: 6, age: 10, year: 2014, height: '', weight: '', relation: '' },
        // add more examples 
    ];

    return (
        <PageContainer>
            <PageHeader title="Data Access Requests" color="#1C4342"></PageHeader>
            <Box px={4} py={8}>
                <Text fontSize={"2.5rem"} color="#1C4342">
                    Data Access Requests
                </Text>
                <Text fontSize={"1.2rem"} color="#1C4342">
                    Pending Data Access Requests:
                </Text>
                <Text fontSize={"1.2rem"} color="#1C4342">
                    • Please approve or deny the specified searcher:
                </Text>

                <Table variant="simple">
                    <Thead>
                        <Tr bg="#1C4342"> {/* Background color for the entire row */}
                            <Th color="white">Record ID</Th>
                            <Th color="white">Age</Th>
                            <Th color="white">Year</Th>
                            <Th color="white">Height</Th>
                            <Th color="white">Weight</Th>
                            <Th color="white">Relation_1</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {tableData.map((data, index) => (
                            <Tr key={index}>
                                <Td>{data.id}</Td>
                                <Td>{data.age}</Td>
                                <Td>{data.year}</Td>
                                <Td>{data.height}</Td>
                                <Td>{data.weight}</Td>
                                <Td>{data.relation}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                    <Box display="flex" mt={4}>
                        <Link to="/approved-request">
                            <Button bg="#1C4342" color="white" mr={2} rounded={4}>
                                Approve
                            </Button>
                        </Link>
                        <Link to="/rejected-request">
                            <Button bg="#1C4342" color="white" rounded={4}>
                                Reject
                            </Button>
                        </Link>

                    </Box>
                </Table>

            </Box>
        </PageContainer>
    );
};

export default PendingRequestsPage;
